import {createAction} from "@reduxjs/toolkit";

const resetAction = createAction('reset');

export { resetAction };